const STATE_STATUSES = {
  UNINITIALIZED: 'UNINITIALIZED',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};

export default STATE_STATUSES;
